import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Grid2, IconButton } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import React from "react";
import type { EmailAddress } from "../../../emailTopics/models/EmailAddress";

type EmailAddressButtonsCellRendererParams =
	ICellRendererParams<EmailAddress> & {
		editEmailAddress: (address: EmailAddress) => void;
		deleteEmailAddress: (address: EmailAddress) => void;
		showContextMenu: (
			event: React.MouseEvent,
			data: EmailAddress,
			configId: string,
		) => void;
	};

export const ButtonsCellRenderer = (
	params: EmailAddressButtonsCellRendererParams,
) => {
	const { editEmailAddress, deleteEmailAddress, showContextMenu, data } =
		params;

	if (!data) {
		return null;
	}

	return (
		<Grid2
			container
			sx={{
				height: "100%",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				opacity: 0,
				transition: "opacity 0.1s ease-in-out",
				".ag-row-hover &": {
					opacity: 1,
				},
				".ag-row-focus &": {
					opacity: 1,
				},
				".ag-row-selected &": {
					opacity: 1,
				},
			}}
		>
			<Grid2
				size={{ md: 12, xs: 12 }}
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					gap: "1rem",
				}}
			>
				<IconButton
					onClick={() => {
						editEmailAddress(data);
					}}
					title="Edit"
					size="small"
				>
					<EditIcon sx={{ height: "auto" }} color="primary" />
				</IconButton>
				<IconButton
					onClick={() => {
						deleteEmailAddress(data);
					}}
					title="Delete"
					size="small"
				>
					<DeleteIcon sx={{ height: "auto" }} color="secondary" />
				</IconButton>
				<IconButton
					onClick={(event) => {
						showContextMenu(event, data, "emailAddressContext");
					}}
					title="Options"
					size="small"
				>
					<FormatListBulletedSharpIcon sx={{ height: "auto" }} color="action" />
				</IconButton>
			</Grid2>
		</Grid2>
	);
};
